// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* eslint:disable */
export const APP_VERSION = {
  "buildDateUTC": "Thu, 17 Apr 2025 21:46:44 GMT",
  "packageVersion": "5.6.2",
  "commitSha": "0c33d59ff050b410f4cd6243e6ebdaf2278f7c78",
  "branch": "development"
};
/* eslint:enable */